import { initSourceDataByCustomEvent } from '../../core/sourceData/thunks.js';
import { addDynamicGlobalTrackingLibraryScript } from '../../../tracking/tools.js';
import { modalNavigationMiddleware } from '../Modal/modalNavigationMiddleware.js';
import { pageNavigationMiddleware } from '../Page/pageNavigationMiddleware.js';
import { getBrandLogoThunk } from '../../core/thunks.js';
import { setActiveWrapper, WRAPPER_TYPES, } from '../../core/wrapperContext/wrapperContextSlice.js';
import { stepModalNavigationMiddleware } from './stepModalNavigationMiddleware.js';
export const initCommonStepModalsDependencies = (encodedGTLibraryUrl, logoBrandName, dispatch, payload) => {
    pageNavigationMiddleware.pause();
    modalNavigationMiddleware.remove();
    stepModalNavigationMiddleware.add();
    addDynamicGlobalTrackingLibraryScript(encodedGTLibraryUrl);
    dispatch(initSourceDataByCustomEvent(payload));
    dispatch(setActiveWrapper(WRAPPER_TYPES.STEP_MODAL));
    dispatch(getBrandLogoThunk(logoBrandName));
};
//# sourceMappingURL=initCommonStepModalsDependencies.js.map